import React, { useContext } from 'react';
import { DSPillV2 } from '@elliemae/ds-pills-v2';
import ComboBoxContext from '../../ComboBoxCTX.js';
import type { DSComboboxT } from '../../react-desc-prop-types.js';
import { getSuggestedValueOnChange } from '../../utils/listHelper.js';

export const RemovableSelectedValuePill: React.ComponentType<{
  pill: DSComboboxT.ItemOption;
  applyAriaDisabled?: boolean;
  trailingComma?: boolean;
}> = (props) => {
  const { pill, trailingComma } = props;
  const {
    props: {
      onChange,
      isNonClearable,
      disabled,
      selectedValues,
      applyAriaDisabled: applyAriaDisabledToContainer,
      readOnly,
    },
    internalRef,
  } = useContext(ComboBoxContext);

  const type = React.useMemo(() => {
    if (disabled || isNonClearable) return 'value';
    if (applyAriaDisabledToContainer || readOnly) return 'labelOnly';
    return 'removable';
  }, [disabled, isNonClearable, applyAriaDisabledToContainer, readOnly]);

  return (
    <DSPillV2
      size="s"
      key={pill.value}
      label={pill.label}
      disabled={disabled}
      type={type}
      applyAriaDisabled={applyAriaDisabledToContainer || pill.applyAriaDisabled}
      readOnly={readOnly}
      trailingComma={trailingComma}
      tabIndex={-1}
      onRemove={(e: React.KeyboardEvent | React.MouseEvent) => {
        if (readOnly) return;
        // preventing the menu to be opened
        e.stopPropagation();
        onChange(getSuggestedValueOnChange(pill, selectedValues), pill, e);
        internalRef.current?.focus();
      }}
    />
  );
};
